/**
 * Eventbird Dropdown
 * Copyright © 2018, Alexander Griffioen <alexander@thenextweb.com>
 * Published under MIT license.
 */

const pluginName = 'ebDropdown'

class EBDropdown {
    constructor(el, options) {
        this.options = $.extend({}, this.defaults, options)
        this.$el = $(el)
        this.init()
    }

    getLabel() {
        return this.$label.text()
    }

    getValue() {
        return this.$input.val()
    }

    init() {
        this.$input = $(`.${this.options.classNameInput}`, this.$el)
        this.$label = $(`.${this.options.classNameLabel}`, this.$el)
        this.value = null

        this.$el.find(`[${this.options.attrValue}]`).on('click', (e) => {
            this.update($(e.currentTarget).attr(this.options.attrValue))
            e.stopPropagation()
        })

        this.$el.on('click', (e) => {
            this.$el.addClass(this.options.classNameFocus)
        })

        $(window).on('click', (e) => {
            if (!$(e.target).closest(this.$el).length) {
                this.$el.removeClass(this.options.classNameFocus)
            }
        })
    }

    update(value) {
        let label

        label = $(`[${this.options.attrValue}='${value}']`, this.$el).attr(this.options.attrLabel)
        
        this.$el.removeClass(this.options.classNameFocus)
        this.$input.val(value)
        this.$label.html(label)

        if (value !== this.value) {
            this.$el.trigger('ebDropdown:change', [value, label])
        }
    }
}

EBDropdown.prototype.defaults = {
    classNameFocus: 'is-focus',
    classNameInput: 'eb-dropdown-input',
    classNameLabel: 'eb-dropdown-label',
    attrLabel: 'data-dropdown-label',
    attrValue: 'data-dropdown-value'
}

$.fn[pluginName] = function (options) {
    return this.each(function () {
        let instance = $(this).data(pluginName)

        if (!instance) {
            $(this).data(pluginName, new EBDropdown(this, options))
        } else {
            if (typeof options === 'string') {
                instance[options]()
            }
        }
    })
}